// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1yk-F","select":"Header_select__nxIIo","clinic":"Header_clinic__2Aro5"};